import { useEffect, useState } from "react";

const useExpiryCountDown = (minutes, isExpiryTimer=true) => {

  const [seconds, setSeconds] = useState((+minutes) * 60);

  const time = new Date(((+minutes) * 60) * 1000).toISOString().slice(11, 19);
  const [timer, setTimer] = useState(time);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds === 0 || isExpiryTimer === false) {
        clearInterval(interval);
        return;
      }
      
      setSeconds((prev) => prev - 1);
      
      // check if seconds is less than 3600 (1 hour) 
      setTimer(new Date(seconds * 1000).toISOString().slice(11, 19));
    }, 1000);

    return () => clearInterval(interval);
  }, [seconds, isExpiryTimer]);

  // remove the first 2 characters from the timer string if the timer is less than 1 hour
  const resultTimer = seconds < 3599 ? timer.substring(3) + " minutes" : timer + " hours";
  return resultTimer;

};

export default useExpiryCountDown;